import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { 
    MapPinIcon, 
    PhoneIcon, 
    EnvelopeIcon, 
    ClockIcon,
    ChatBubbleLeftRightIcon,
    PaperAirplaneIcon
} from '@heroicons/react/24/outline';
import api from '../utils/api';

function ContactPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            // İletişim formu API'sine gönder (backend'de endpoint oluşturulacak)
            await api('/api/contact', {
                method: 'POST',
                body: JSON.stringify(formData)
            });
            
            toast.success('Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.');
            setFormData({
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            });
        } catch (error) {
            toast.error('Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-brand-green to-brand-green-light text-white py-12 sm:py-16">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
                        Bizimle İletişime Geçin
                    </h1>
                    <p className="text-lg sm:text-xl opacity-90 max-w-2xl mx-auto">
                        Sorularınız, önerileriniz veya yardıma ihtiyacınız mı var? 
                        Size yardımcı olmaktan mutluluk duyarız!
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    
                    {/* İletişim Bilgileri */}
                    <div className="lg:col-span-1 space-y-6">
                        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                                <ChatBubbleLeftRightIcon className="w-6 h-6 text-brand-green mr-2" />
                                İletişim Bilgileri
                            </h2>
                            
                            <div className="space-y-4">
                                <div className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                                    <MapPinIcon className="w-5 h-5 text-brand-green mt-1 flex-shrink-0" />
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Adres</h3>
                                        <p className="text-gray-600 text-sm">
                                            OSMANGAZİ mahallesi, RASİM SOKAK<br />
                                            OSMANGAZİ MAH. RASİM SK. 6/1<br />
                                            SANCAKTEPE/İstanbul
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                                    <PhoneIcon className="w-5 h-5 text-brand-green mt-1 flex-shrink-0" />
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Telefon</h3>
                                        <p className="text-gray-600 text-sm">+90 555 260 94 20</p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                                    <EnvelopeIcon className="w-5 h-5 text-brand-green mt-1 flex-shrink-0" />
                                    <div>
                                        <h3 className="font-semibold text-gray-800">E-posta</h3>
                                        <p className="text-gray-600 text-sm">info@minelakids.com</p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                                    <ClockIcon className="w-5 h-5 text-brand-green mt-1 flex-shrink-0" />
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Çalışma Saatleri</h3>
                                        <p className="text-gray-600 text-sm">
                                            Pazartesi - Cuma: 09:00 - 18:00<br />
                                            Cumartesi: 10:00 - 16:00<br />
                                            Pazar: Kapalı
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Hızlı Linkler */}
                        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                            <h3 className="text-lg font-bold text-gray-800 mb-4">Hızlı Linkler</h3>
                            <div className="space-y-2">
                                <a href="/sss" className="block text-brand-green hover:text-brand-green-light transition-colors text-sm">
                                    → Sıkça Sorulan Sorular
                                </a>
                                <a href="/iade-kosullari" className="block text-brand-green hover:text-brand-green-light transition-colors text-sm">
                                    → İade Koşulları
                                </a>
                                <a href="/teslimat-bilgileri" className="block text-brand-green hover:text-brand-green-light transition-colors text-sm">
                                    → Teslimat Bilgileri
                                </a>
                                <a href="/kargo-takip" className="block text-brand-green hover:text-brand-green-light transition-colors text-sm">
                                    → Kargo Takip
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* İletişim Formu */}
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 border border-gray-100">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                                <PaperAirplaneIcon className="w-6 h-6 text-brand-green mr-2" />
                                Bize Mesaj Gönderin
                            </h2>
                            
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Ad Soyad *
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all"
                                            placeholder="Adınızı ve soyadınızı girin"
                                        />
                                    </div>
                                    
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            E-posta *
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all"
                                            placeholder="E-posta adresinizi girin"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Telefon
                                        </label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all"
                                            placeholder="Telefon numaranızı girin"
                                        />
                                    </div>
                                    
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Konu *
                                        </label>
                                        <select
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all"
                                        >
                                            <option value="">Konu seçin</option>
                                            <option value="genel">Genel Bilgi</option>
                                            <option value="siparis">Sipariş Sorunu</option>
                                            <option value="iade">İade/Değişim</option>
                                            <option value="kargo">Kargo Sorunu</option>
                                            <option value="urun">Ürün Bilgisi</option>
                                            <option value="oneri">Öneri/Şikayet</option>
                                        </select>
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Mesajınız *
                                    </label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        required
                                        rows={6}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all resize-none"
                                        placeholder="Mesajınızı detaylı olarak yazın..."
                                    />
                                </div>

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="w-full bg-gradient-to-r from-brand-green to-brand-green-light text-white font-bold py-4 px-6 rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                                >
                                    {isSubmitting ? (
                                        <span className="flex items-center justify-center">
                                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Gönderiliyor...
                                        </span>
                                    ) : (
                                        <span className="flex items-center justify-center">
                                            <PaperAirplaneIcon className="w-5 h-5 mr-2" />
                                            Mesajı Gönder
                                        </span>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Harita Bölümü */}
                <div className="mt-12">
                    <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                            <MapPinIcon className="w-6 h-6 text-brand-green mr-2" />
                            Konumumuz
                        </h2>
                        <div className="w-full h-64 sm:h-96 bg-gray-200 rounded-lg overflow-hidden">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.8234567890123!2d29.1234567!3d41.0234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDAxJzI0LjQiTiAyOcKwMDcnMjQuNCJF!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Minela Kids Konum"
                            ></iframe>
                        </div>
                        <p className="text-sm text-gray-600 mt-4 text-center">
                            Mağazamızı ziyaret etmek için yukarıdaki haritayı kullanabilirsiniz.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactPage;